import constants from 'utils/addresses/constants';

const getCoordinatesFromPOIAddress = (POIAddressData) => {
  const geometryData = POIAddressData.geometry || {};
  let rawCoordinates = geometryData.coordinates || [];

  let coordinates = {};
  if (
    rawCoordinates &&
    geometryData.type === constants.POI_ADDRESS_CONSTANTS.geometry_point_type
  ) {
    const [longitude, latitude] = rawCoordinates;
    coordinates = {
      latitude,
      longitude,
    };
  }

  return coordinates;
};

export default getCoordinatesFromPOIAddress;
